import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { EditReferringToFormValues } from '@/components/misc/ReferralDetails/components/ApprovalRequestModal/components/ReviewRequest/types'
import { RootState } from '@/redux/store'
import { ReferralApprovalRequestMetadataItem } from '@/types/responses/referral-metadata'

export interface ReferralApprovalRequest {
  metadata?: ReferralApprovalRequestMetadataItem
  referringToFormValues?: EditReferringToFormValues
}

const INITIAL_STATE: ReferralApprovalRequest = {}

const referralApprovalRequest = createSlice({
  name: 'referralApprovalRequest',
  initialState: INITIAL_STATE,
  reducers: {
    reset() {
      return INITIAL_STATE
    },
    setReferringToFormValues(
      state,
      action: PayloadAction<ReferralApprovalRequest['referringToFormValues']>,
    ) {
      state.referringToFormValues = action.payload
    },
    setReferralApprovalRequestMetadata(
      state,
      action: PayloadAction<ReferralApprovalRequest['metadata']>,
    ) {
      state.metadata = action.payload
    },
  },
})

export const selectReferralApprovalRequest = (state: RootState) =>
  state.referralApprovalRequest

export const selectReferringToFormValues = createSelector(
  selectReferralApprovalRequest,
  (state) => state.referringToFormValues,
)

export const selectUserEmailMessage = createSelector(
  selectReferringToFormValues,
  (referringToFormValues) => referringToFormValues?.userEmailMessage,
)

export const selectReferralApprovalRequestMetadata = createSelector(
  selectReferralApprovalRequest,
  (state) => state.metadata,
)

export const {
  reset,
  setReferralApprovalRequestMetadata,
  setReferringToFormValues,
} = referralApprovalRequest.actions

export const referralApprovalRequestReducer = referralApprovalRequest.reducer
